import React, { FC } from 'react';

export type TextAreaProps = {
  id?: string;
  name?: string;
  className?: string;
  label?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  rows?: number;
  cols?: number;
  maxLength?: number;
  error?: string;
  variant?: 'primary' | 'secondary';
}

export const TextArea: FC<TextAreaProps> = ({
  id,
  name,
  className,
  label,
  value = '',
  onChange,
  placeholder = '',
  disabled = false,
  rows = 4,
  cols = 4,
  maxLength,
  error,
  variant = 'primary',
}) => {

  return (
    <div className="relative flex flex-col gap-1 w-full">
      {label && <label htmlFor={name} className={`text-sm font-medium ${variant === "primary" ? "" : "text-[#D0D5DD]"}`}>{label}</label>}
      <textarea
        id={id}
        name={name}
        value={value}
        onChange={(e) => onChange?.(e)}
        rows={rows}
        cols={cols}
        maxLength={maxLength}
        disabled={disabled}
        placeholder={placeholder}
        className={`block w-full rounded-md shadow-sm ${variant === "primary" ? "" : "text-white bg-black"} focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary-700 focus:ring-0 focus:border-transparent ${className}
        ${error ? "outline !outline-2 -outline-offset-2 outline-red-500" : "border border-secondary-20"}`}
      />
      {error && <p className="absolute -bottom-4 text-sm leading-none text-red-500">{error}</p>}
    </div>
  );
};